import { preloadAdmin } from './adminRouteTree';
import { preloadCO2Impact } from './co2ImpactRouteTree';
import { preloadCSRD } from './csrdRouteTree';
import { preloadEnvironment } from './environmentRouteTree';
import { preloadFollowup } from './followupRouteTree';
import { preloadLearning } from './learningRouteTree';
import { preloadPickups } from './pickupRouteTree';

export const preloadApps = () => {
  preloadAdmin();
  preloadPickups();
  preloadFollowup();
  preloadCO2Impact();
  preloadCSRD();
  preloadEnvironment();
  preloadLearning();
};
